<template>
    <employee-list
        :users="users"
        :count="count"
        :page="params.page"
        v-on="$listeners"
        @updateTable="onUpdateTable"
        @refresh="onRefresh"
    />
</template>

<script>
import userListMixin from '@/mixins/UserList';

export default {
    name: 'employeeAdminList',

    mixins: [userListMixin],

    data() {
        return {
            params: {
                role: 'admin'
            }
        };
    }
};
</script>
